module.exports = __webpack_public_path__ + "img/growing-plant.7416ce4e.gif";